import * as KeyDownShortCuts from '../shortcuts/KeyDownShortCuts';

const shortcuts = {
    ...KeyDownShortCuts
};

export default shortcuts;
